import { getElement, getElements, toggleClass } from '../helpers/functions';
export default () => {
  const $footerAccordions = getElements('.footer-accordion');
  $footerAccordions.forEach($accordion => {
    const $label = getElement('.footer-accordion--button', $accordion);
    const $frame = getElement('.footer-accordion--body', $accordion);
    if (!$label || !$frame) return;
    $label.addEventListener('click', () => {
      toggleClass($frame, '__open');
    });
  });
};